import { IPageLayoutProps } from "../../IConfiguration";
import * as React from 'react';
import * as classNames from "classnames";
import { withTheme } from "../../../../../common/withTheme";
import FooterPlatypus from "../../../../Page/Footer/FooterPlatypus";
import MenuItemList from "../../../MenuItems";
import NavMenu from "../../../NavMenu";

class PageLayoutContent extends React.Component<IPageLayoutProps, any> {
    constructor(props, context) {
        super(props, context);
    }

    render() {

        return (
            <div className={classNames(this.props.theme, "content-wrapper h-100")}>
                <div
                    className={classNames(
                        this.props.theme,
                        "content-container",
                        "banner-container",
                        "text-center",
                        "position-relative"
                    )}
                >
                    <div
                        className={classNames(
                            this.props.theme,
                            "background-image background-image-banner"
                        )}
                    >
                    </div>
                    <div className="w-100 text-white position-absolute banner-text container">
                        <h1>Australian Platypus Monitoring Network</h1>
                        <h2>People Assisting Platypus Conservation</h2>
                    </div>
                </div>

                <NavMenu>
                    {MenuItemList(this.props.pages, this.props.currentUser, "nav-item nav-link")}
                </NavMenu>

                <div className={classNames(this.props.theme, "page-break")} />
                <div
                    className={classNames(
                        this.props.theme,
                        "container content-container"
                    )}
                    style={{
                        marginTop: "0px",
                        marginBottom: "50px",
                        maxWidth: "760px",
                        marginLeft: "auto",
                        marginRight: "auto"
                    }}
                >
                    {this.props.children}
                </div>
                <FooterPlatypus />
            </div>
        );
    }
}


//<div className={classNames(this.props.theme, "content-page-container")} >
//    {this.props.menu}
//    {this.props.children}
//</div>

export default withTheme<IPageLayoutProps>(PageLayoutContent);